import ChatTemplate from "components/shared/chat";
import Body from "components/shared/chat/body";
import Footer from "components/shared/chat/footer";
import Loader from "components/shared/loader";
import { useUnreadItems } from "contexts/unreadItemsContext";
import { chatTypesEnum } from "helpers/enums";
import { chatContainer } from "helpers/redux";
import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { getParticipant } from "sources/messages";

const initialState = {
    isLoading: true,
    openedDropd: false,
    rate: {},
    info: {},
    system: false,
    onlyMyMessages: false,
    organization: {
        imageUrl: "",
        name: "Organization",
        id: 0,
    },
};

class Chat extends ChatTemplate {
    getData = (props) => {
        const { chatId } = props || this.props;
        this.setState(initialState);
        getParticipant(chatId)
            .then((res) => this.handleParticipant(res))
            .finally(() => this.setState({ isLoading: false }));
    };

    render() {
        const { info, onlyMyMessages } = this.state;
        const { chatId, profile, token, modal, mergeChatsParams } = this.props;

        const props = {
            chatId,
            info,
            profile,
            token,
            updateChats: mergeChatsParams,
            modal: this.props.modal,
            onlyMyMessages,
        };

        return this.state.isLoading ? (
            <Loader prefix="absolute-center" />
        ) : (
            <div className="chat-layout px-0 py-0 vh-50">
                <Body {...props}>
                    <Footer chatId={chatId} modal={modal} info={this.state.info} theme={this.props.theme} />
                </Body>
            </div>
        );
    }
}

const ChatWrapper = (props) => {
    const { readItems } = useUnreadItems();

    useEffect(() => {
        if (props.chatId) {
            readItems({ chatId: props.chatId, chatType: chatTypesEnum.FixRouteBidChat });
        }
    }, [props.chatId]);

    return <Chat {...props} />;
};

export default withRouter(chatContainer(ChatWrapper));
